import Swiper from 'swiper';

//モジュールのインポート
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css';

export function recruitFunc() {
  const swiper = new Swiper(".swiper", {
    modules: [Autoplay, Pagination, Navigation],
    loop: true,
    speed: 1500,
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 3000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      767: {
        slidesPerView: 4,
        spaceBetween: 50,
      }
    }
  });
}